import { Link } from "react-router";
import "./footer.css";
import { BsInstagram } from "react-icons/bs";
import { FaFacebookF, FaTiktok, FaWhatsapp } from "react-icons/fa";
import footerLogo from "../../Media/zakarry-logo-white.png"
import { BUSINESS_WHATSAPP_NUMBER } from "../../Utilities/whatsapp";

export default function Footer() {
  return (
    <div className="footer">
      <div className="footer-top">
        <div className="footer-logo">
          <Link to="/">
            <img
              src={footerLogo}
              className="logo"
              alt="Logo"
              loading="lazy"
              decoding="async"
            />
          </Link>
          <p>Crafting Visions, One step at a Time.</p>
        </div>
        <div className="footer-links">
          <Link to="/shop">SHOP</Link>
          <Link to="/about">ABOUT</Link>
          <Link to="/contact">CONTACT</Link>
          <Link to="/gallary">GALLARY</Link>
          <Link to="/services">SERVICES</Link>
        </div>
      </div>

      <div className="footer-mid">
        <div className="mid-left">
          <h4>Address</h4>
          <p>Accra, Ghana</p>
          <div className="footer-socials">
            <a href="https://www.instagram.com/zak_arryy/">
              <BsInstagram />
            </a>
            <a href="">
              <FaFacebookF />
            </a>
            <a href="">
              <FaTiktok />
            </a>
            <a href={`https://wa.me/${BUSINESS_WHATSAPP_NUMBER}`}>
              <FaWhatsapp />
            </a>
          </div>
        </div>
        <div className="mid-mid">
          <h4>Contact</h4>
          <a href="tel:233555694020">
            <p>Phone: +233 555 694 020</p>
          </a>
          <a href="tel:233203353727">
            <p>Phone: +233 203 353 727</p>
          </a>
          <a href="mailto:zakarry540@gmail.com">
            <p>Email: zakarry540@gmail.com</p>
          </a>
        </div>
        <div className="mid-right">
          <h4>Let's Talk About Fashion</h4>
          <p>
            Reach out and let’s begin the journey of crafting something
            exceptional, tailored just for you.
          </p>
          <Link to="/booking">
            <button>BOOK APPOINTMENT</button>
          </Link>
        </div>
      </div>

      <div className="footer-down">
        <p>COPYRIGHT © 2025 ZAKARRY</p>
        <p>BUILT BY BILL</p>
      </div>
    </div>
  );
}
